import * as typeformEmbed from '@typeform/embed';
import cn from 'classnames';
import RibbonText from 'modules/content-cms/components/ribbon-text';
import React, { CSSProperties } from 'react';
import { gtm, Gtm } from 'tracking/gtm';
import Button from '../../../../components/button';
import { ISectionTypeformFields } from '../../../../global';
import ContentContainer from '../components/content-container';

/** Component to display Typeform app for Contentful  */
const Typeform: React.FC<ISectionTypeformFields> = ({
  title,
  url,
  buttonText,
  buttonSize,
  customBackgroundColor,
  disableSpacing,
  backgroundColor,
  richTitle,
}) => {
  const typeformRef = React.useRef({
    open: () => true,
  });

  React.useEffect(() => {
    typeformRef.current = typeformEmbed.makePopup(url, {
      mode: 'popup',
      autoClose: 3000,
      autoOpen: false,
      hideHeaders: true,
      hideFooters: true,
      onSubmit: function () {
        gtm({
          group: Gtm.GroupName.Form,
          name: Gtm.CommonEventName.Submit,
          data: {
            label: title,
          },
        });
      },
    });
  }, [url, title]);

  const buttonStyle = {} as CSSProperties;

  if (customBackgroundColor) {
    buttonStyle.backgroundColor = `${customBackgroundColor}`;
  }

  return (
    <ContentContainer
      disableSpacing={disableSpacing}
      backgroundColor={backgroundColor ? backgroundColor : '#fff'}
    >
      {richTitle && <RibbonText text={richTitle} />}
      <div
        className={cn(
          'flex w-full justify-center text-center',
          !disableSpacing && '-mt-8 md:-mt-10'
        )}
      >
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html: `
          div[data-section-id=header] {
            z-index: 10000 !important;
          }
        `,
          }}
        ></style>
        <Button
          layout="brand"
          size={buttonSize}
          onClick={() => {
            typeformRef.current.open();
          }}
          style={buttonStyle}
        >
          {buttonText ? buttonText : 'Starten'}
        </Button>
      </div>
    </ContentContainer>
  );
};

export default Typeform;
